export default function CTA() {
  return (
    <section className="cta-section">
      <div className="container text-center">
        <h2 className="cta-title">Want a quick chat?</h2>
        <p className="cta-intro">We're a phone call or email away.</p>
        <div className="cta-links">
          <a href="tel:+64211220200" className="cta-link">+64 2112 20200</a>
          <span className="cta-sep">·</span>
          <a href="mailto:chiechelski+leadingng@gmail.com" className="cta-link">chiechelski+leadingng@gmail.com</a>
        </div>
      </div>

      <style>{`
        .cta-section {
          padding: 56px 20px;
          background: linear-gradient(180deg, var(--color-bg-dark) 0%, #16202a 100%);
          color: #fff;
          border-top: 3px solid var(--color-primary);
        }
        .cta-title { margin: 0 0 8px; font-size: 1.6rem; font-weight: 700; letter-spacing: -0.02em; }
        .cta-intro { margin: 0 0 16px; font-size: 1rem; opacity: 0.9; }
        .cta-links { display: flex; flex-wrap: wrap; justify-content: center; align-items: center; gap: 8px 12px; }
        .cta-link {
          color: #fff;
          font-weight: 600;
          font-size: 1.05rem;
          transition: color 0.2s ease;
        }
        .cta-link:hover { color: var(--color-primary); text-decoration: none; }
        .cta-sep { opacity: 0.5; font-weight: 300; }
      `}</style>
    </section>
  );
}
